var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 4,
  fill: "#F2F2F2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M26.8182 26H7.18182C6.65263 26 6 25.4606 6 24.5V18.25V15.75V9.5C6 8.53938 6.65263 8 7.18182 8H26.8182C27.3474 8 28 8.53938 28 9.5V15.75V18.25V24.5C28 25.4606 27.3474 26 26.8182 26Z",
  stroke: "black",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M11 14L15.5858 18.5858C16.3668 19.3668 17.6332 19.3668 18.4142 18.5858L23 14",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M11 20L14 17M23 20L20 17",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export { SvgMail as ReactComponent };